<div>An unexpected error occurred. Please try again later.</div>
<br/>
<div class="close-button-area">
  <button mat-raised-button mat-dialog-close color="primary">
    Close
  </button>
</div>
